export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp();
  const auth = useAuthStore();
  const toast = useToast();

  if (auth.logged && auth?.user?.must_verify_email) {
    const userLocale = auth?.user?.preferred_language || 'en';
    const targetRoute = userLocale === 'en' ? '/auth/confirm-email-address' : `/${userLocale}/auth/confirm-email-address`;

    return nuxtApp.runWithContext(() => {
      toast.add({
        severity: "error",
        summary: "Please confirm your email.",
        life: 3000,
      });

      return navigateTo(targetRoute);
    });
  }
});
